<section *ngIf="showCookie">
  <div class="overlay"></div>
  <div class="cookies">
    <div class="container">
      <div class="icon">
        <img
          src="assets/images/cookies-icon.svg"
          alt="Cookies icon"
          title="Cookies icon"
          class="center-block"
        />
      </div>
      <div class="message">
        <p
          [innerHTML]="'sharedModule.bkgCookiesAdvice.textHtml' | translate"
        ></p>
      </div>
      <div class="btn-container">
        <div class="understood">
          <a
            class="btn btn-primary btn-sm"
            title="{{ 'sharedModule.bkgCookiesAdvice.accept' | translate }}"
            role="button"
            id="acceptCookies"
            (click)="setAcceptedCookies()"
          >
            {{ 'sharedModule.bkgCookiesAdvice.accept' | translate }}
          </a>
        </div>
        <div class="rejected-cookies">
          <a
            class="btn btn-sm"
            title="{{ 'sharedModule.bkgCookiesAdvice.reject' | translate }}"
            role="button"
            id="rejectCookies"
            (click)="setRejectedCookies()"
          >
            {{ 'sharedModule.bkgCookiesAdvice.reject' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
